import Vue from 'vue'
import Vuex from 'vuex'
import { DEFAULT_LINES, API_PREFIX, TOKEN_STORAGE } from '@/config'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    room: { id: '', name: '', expireAt: '' },
    user: { name: '', token: localStorage.getItem(TOKEN_STORAGE) || '' },
    dnd: false,
    dark: false, // 夜间模式
    // 线路切换(对齐原站 线路1-4)
    lines: DEFAULT_LINES,
    currentLine: 0,
    online: 0,
    // 游戏列表:全站单一响应式数据源(main.js 启动前同步 seed,fetchGames 供将来接口刷新)
    games: []
  },
  getters: {
    currentApiBase: (s) => (s.lines[s.currentLine]?.api || '') + API_PREFIX,
    currentWs: (s) => s.lines[s.currentLine]?.ws || '',
    games: (s) => s.games
  },
  mutations: {
    setRoom(state, room) { state.room = { ...state.room, ...room } },
    setUser(state, user) {
      state.user = { ...state.user, ...user }
      if (user.token !== undefined) localStorage.setItem(TOKEN_STORAGE, user.token || '')
    },
    setDnd(state, v) { state.dnd = v },
    setDark(state, v) { state.dark = v; document.documentElement.classList.toggle('dark', !!v) },
    setLines(state, lines) { state.lines = lines },
    setCurrentLine(state, i) { state.currentLine = i },
    setOnline(state, n) { state.online = n },
    setGames(state, list) { state.games = list },
    updateGame(state, { code, patch }) {
      const g = state.games.find((x) => x.code === code)
      if (g) Object.assign(g, patch)
    }
  },
  actions: {
    async fetchGames({ commit }) {
      // TODO: 接后台接口时替换为 const list = await api.getGames()
      const { GAMES } = await import('@/config/games')
      commit('setGames', JSON.parse(JSON.stringify(GAMES)))
    }
  }
})
